import {IToJson} from '@toolify/client/src/types/IToJson'
import {IUsageEventResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUsageEventResponseInstance'
import {mapResponseEntity} from './mapResponseEntity'

export function mapUsageEventResponseInstance(
  usageEvent: IToJson<IUsageEventResponseInstance>,
): IUsageEventResponseInstance {
  return {
    ...usageEvent,
    occurredAt: new Date(usageEvent.occurredAt),
    createdAt: usageEvent.createdAt ? new Date(usageEvent.createdAt) : undefined,
    actorEntity: usageEvent.actorEntity ? mapResponseEntity(usageEvent.actorEntity) : null,
  }
}
